import { decorators } from '@sohohouse/platform-resources'

const { DateTime } = decorators.shared

export default (cancellableUntil, $t, $d) => {
  if (cancellableUntil) {
    const cancelDate = new DateTime(cancellableUntil)
    if (cancelDate.inPast) {
      return $t('STAY_BOOKED_CANCELLATION_NO_REFUND_SUPPORTING')
    }
    // Note: All hotels' cancel 
    // cutoff time is 6 PM locally.
    // This configuration will display '6 PM' 
    // but the message will disappear when that time 
    // passes in the user's time zone.
    const cancelTime = new DateTime({ hours: 18 })

    const time = $d(cancelTime.epoch, 'time')
    const date = $d(cancelDate.withOffset.epoch, 'shortDate')
    return $t('STAY_ROOM_CANCELLATION_HOURS_SUPPORTING', { time, date })
  }
  return $t('STAY_ROOM_CANCELLATION_NO_REFUND_SUPPORTING')
}

